import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request to keep it out of the global full-screen loader (loader.interceptor.ts).
 * Used by background polling (e.g. PacService.checkBlockStatus) where a fast round trip every
 * few seconds would otherwise flash the overlay on and off.
 */
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);
